export default __webpack_public_path__ + "static/media/green-check-benefit-table.c6420c0e.svg";